import { createContext, useContext, useState, ReactNode } from 'react';

interface DocsScrollContextType {
  currentDocPath: string;
  scrollProgress: number;
  setCurrentDocPath: (path: string) => void;
  setScrollProgress: (progress: number) => void;
}

export const DocsScrollContext = createContext<DocsScrollContextType | undefined>(undefined);

export const DocsScrollProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currentDocPath, setCurrentDocPath] = useState('');
  const [scrollProgress, setScrollProgress] = useState(0);

  return (
    <DocsScrollContext.Provider
      value={{
        currentDocPath,
        scrollProgress,
        setCurrentDocPath,
        setScrollProgress
      }}
    >
      {children}
    </DocsScrollContext.Provider>
  );
};

export const useDocsScroll = () => {
  const context = useContext(DocsScrollContext);
  if (!context) {
    throw new Error('useDocsScroll must be used within DocsScrollProvider');
  }
  return context;
};
